import React, { useRef, useState, useEffect, Fragment, Component } from "react";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";

import axios from "../../../../api/axios";
import {
  Paper,
  Box,
  Grid,
  Typography,
  responsiveFontSizes,
  TextField,
} from "@mui/material";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";

import "../Operations.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as XLSX from "xlsx";
import { useLocation } from "react-router-dom";
import { url } from "../../../../configlink";
import { useSelector } from "react-redux";

export default function UploadPrimerExcel() {
  const [openDialogName, setOpenDialog] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [progressInfos, setProgressInfos] = useState({ val: [] });
  const [message, setMessage] = useState([]);
  const [fileInfos, setFileInfos] = useState([]);
  const progressInfosRef = useRef(null);

  const [rows, setRows] = useState([]);

	let adminUser = useSelector((state) => state.userAdmin.userAdmin)

  let loc = useLocation()

  let selectedUserId = loc.search.split('=')[1]
  // let selectedUserId = 18749

  console.log(selectedUserId);

	useEffect(() => {
		getUserPrimerLists();
	}, [])

  
  const handleDeleteClick = (id) => () => {
    // alert("chosed id===" + id);

	axios
		.delete(`${url}/api/admin/delete_primerdetail_by_id/${id}`, {
			withCredentials:true,
			headers: {
				'acgt-admin': adminUser
			}
		})
      .then((response) => {
        console.log("Resource deleted successfully:", response.data);
      })
      .catch((error) => {
        console.error("Error deleting resource:", error);
      });

    setRows(rows.filter((row) => row.id !== id));

    /*
      setRowModesModel({
        ...rowModesModel,
        [id]: { mode: GridRowModes.View, ignoreModifications: true },
      });
      */
    /*const editedRow = rows.find(row => row.id === id);
      if (editedRow.isNew) {
        setRows(rows.filter(row => row.id !== id));
      }
      */
  };

  const getUserPrimerLists = async () => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_user_primer_lists`,
        {
          params: { userId: selectedUserId },
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );
      console.log(response.data);
      setRows(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const closeDialog = () => {
    setOpenDialog(null);
    // paymentId.current = 0;
  };

  const openDialog = () => {
    // alert("OpenDialog =======>    " + userId);
    /*alert('Selected Userid====' + userId);
    switch (openDialogName) {
      case 1:
        setOpenDialog(openDialogName);
        handleClose();
    }*/
  };

  /*
  const uploadFiles = useCallback(e => {
    const file = e.target.files[0];
    var reader = new FileReader();
    reader.onload = function(e) {
      var data = new Uint8Array(e.target.result);
      var workbook = XLSX.read(data, { type: 'array' });
      var firstSheet = workbook.SheetNames[0];
      setIsReading(false);
      const elements = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);
      console.log('Excel read OK!');
      console.log('Found ' + elements.length + ' elements');
      console.log('JSON size', JSON.stringify(elements).length, 'bytes');
    };
    setIsReading(true);
    reader.readAsArrayBuffer(file);
  }, []);
  */
  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, { type: "buffer" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data2 = XLSX.utils.sheet_to_json(ws, { header: 1 });
        // const jsonArray = utils.sheet_to_json(worksheet, {
        //   header: ["B", "D"],
        //   blankrows: false,
        // });
		
		const data = data2.map((row, rowIndex) =>
          row.map((cell, colIndex) => {
            // Check if it's the 3rd column (index 2) and the cell is a date serial
            if (colIndex === 2 && typeof cell === "number") {
              const date = XLSX.SSF.parse_date_code(cell);
              if (date) {
                // Convert to readable date string, e.g., "YYYY-MM-DD"
                return `${String(date.m).padStart(2, "0")}/${String(date.d).padStart(2, "0")}/${date.y}`;
              }
            }
            return cell; // Keep other cells as is
          })
        );
		
        console.log("json length====" + data.length);

        let tableHeaderStarts = 9
        if(data[9][1] === 'Primer Name'){
          tableHeaderStarts = 10
        }

        var mainarr = [];
        for (let row = tableHeaderStarts; row <= data.length; row += 1) {
			console.log(data[row]);
			
          if (data[row] === undefined || data[row].length === 0 || (data[row].length === 1 && typeof data[row][0] === 'number') ) break;
          else {
            var tmpDate = data[row][2] === undefined ? "" : data[row][2];
            var tmpSeq = data[row][3] === undefined ? "" : data[row][3];

            mainarr.push({
              PrimerName: data[row][1],
              PrimerDate: tmpDate,
              PrimerSequence: tmpSeq,
            });
          }
        }

        const json = JSON.stringify(mainarr);
        resolve(json);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then(async (json) => {
      console.log("front end selectedUserID===" + selectedUserId);
      try {
        const response = await axios.put(
          `${url}/api/admin/post_user_primer_lists`,
          json,
          {
            headers: {
				"Content-Type": "application/json",
				'acgt-admin': adminUser
            },
            params: { userId: selectedUserId },
			withCredentials: true,
          }
        );

        getUserPrimerLists();
      } catch (error) {
        console.error(error);
		alert("Error")
      }
    });
  };

  const columns = [
    { field: "id", headerName: "Id", type: "number", hide: false, width: 100 },
    {
      field: "PrimerName",
      headerName: "PrimerName",
      type: "string",
      width: 170,
      editable: false,
    },
    {
      field: "PrimerDate",
      headerName: "PrimerDate",
      type: "string",
      width: 110,
      editable: false,
    },
    {
      field: "PrimerSequence",
      headerName: "PrimerSequence",
      type: "string",
      width: 300,
      editable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      width: 15,
      cellClassName: "actions",
      getActions: ({ id, i }) => {
        return [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            onClick={handleDeleteClick(id)}
            label="Edit"
            className="textPrimary"
            color="inherit"
            key={i}
          />,
        ];
      },
    },
  ];

  return (
    <div style={{ padding: 25, paddingTop: 10, paddingBottom: 10 }}>
          <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
            <Box sx={{ my: 3, mx: 2 }}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item xs>
                  {/* any elements nested inside the role="presentation" preserve their semantics. */}
                  <Typography gutterBottom variant="h5" component="div">
                    User Primer List
                  </Typography>
                </Grid>
              </Grid>
              <Divider component="div" role="presentation" />

              <Grid container alignItems="center" spacing={1}>
                <Grid item xs>
                  <Typography color="text.secondary" variant="body2">
                    Please upload the new excel carefully since the previous
                    primers lists will be removed permanantly
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Grid container alignItems="center" spacing={1}>
                <Grid item xs>
                  <DataGrid
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          //  Hide columns status and traderName, the other columns will remain visible
                          id: false,
                        },
                      },
                    }}
                    pagination
                    autoPageSize
                    style={{ width: "100%", height: "550px", padding: "10px" }}
                    columnHeaderHeight={30}
                    rowHeight={30}
                    rows={rows}
                    columns={columns}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ margin: 3 }}>
              <Grid container alignItems="flex-start" spacing={1}>
                <Grid item xs={6}>
                  <input
                    type="file"
                    accept=".xls, .xlsx"
                    multiple
                    onChange={(e) => {
                      const file = e.target.files[0];
                      readExcel(file);
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </div>
  );
}
